import React from "react";
import StudentHostelDetails from "../../components/AdminTabs/AdminStudentHostelFee/StudentHostelDetails";

const StudentHostelDetailsPage = () => {
  return (
    <div>
      <StudentHostelDetails />
    </div>
  );
};

export default StudentHostelDetailsPage;
